function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0,165.014v272.984c0,24.198,19.687,43.885,43.885,43.885h424.23c24.198,0,43.885-19.686,43.885-43.884V165.014H0z  M169.541,415.405c0,5.567-4.513,10.079-10.079,10.079H95.103c-5.567,0-10.079-4.513-10.079-10.079v-66.587 c0-5.567,4.513-10.079,10.079-10.079h64.359c5.567,0,10.079,4.513,10.079,10.079V415.405z M169.541,288.915 c0,5.567-4.513,10.079-10.079,10.079H95.103c-5.567,0-10.079-4.513-10.079-10.079v-66.587c0-5.567,4.513-10.079,10.079-10.079 h64.359c5.567,0,10.079,4.513,10.079,10.079V288.915z M298.259,415.405c0,5.567-4.513,10.079-10.079,10.079h-64.359 c-5.567,0-10.079-4.513-10.079-10.079v-66.587c0-5.567,4.513-10.079,10.079-10.079h64.359c5.567,0,10.079,4.513,10.079,10.079 V415.405z M298.259,288.915c0,5.567-4.513,10.079-10.079,10.079h-64.359c-5.567,0-10.079-4.513-10.079-10.079v-66.587 c0-5.567,4.513-10.079,10.079-10.079h64.359c5.567,0,10.079,4.513,10.079,10.079V288.915z M426.977,415.405 c0,5.567-4.513,10.079-10.079,10.079h-64.359c-5.567,0-10.079-4.513-10.079-10.079v-66.587c0-5.567,4.513-10.079,10.079-10.079 h64.359c5.567,0,10.079,4.513,10.079,10.079V415.405z M426.977,288.915c0,5.567-4.513,10.079-10.079,10.079h-64.359 c-5.567,0-10.079-4.513-10.079-10.079v-66.587c0-5.567,4.513-10.079,10.079-10.079h64.359c5.567,0,10.079,4.513,10.079,10.079 V288.915z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M468.115,67.768h-41.742V45.236c0-8.35-6.769-15.119-15.119-15.119s-15.119,6.769-15.119,15.119v22.532h-47.388V45.236 c0-8.35-6.769-15.119-15.119-15.119c-8.35,0-15.119,6.769-15.119,15.119v22.532H271.12V45.236c0-8.35-6.769-15.119-15.119-15.119 s-15.119,6.769-15.119,15.119v22.532h-47.389V45.236c0-8.35-6.769-15.119-15.119-15.119c-8.35,0-15.119,6.769-15.119,15.119 v22.532h-47.388V45.236c0-8.35-6.769-15.119-15.119-15.119c-8.35,0-15.119,6.769-15.119,15.119v22.532h-0.002H43.885 C19.687,67.768,0,87.455,0,111.653v33.203h512v-33.203C512,87.455,492.313,67.768,468.115,67.768z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function SvgCalendarBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlack);
export default __webpack_public_path__ + "static/media/calendar_black.7b3dced2.svg";
export { ForwardRef as ReactComponent };